import { render } from "./index.vue?vue&type=template&id=0597f9c8"
import script from "./content-dropdown.ts?vue&type=script&lang=js"
export * from "./content-dropdown.ts?vue&type=script&lang=js"

import "./content-dropdown.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script